import type { FC } from 'react';
import React from 'react';
import compose from 'compose-function';
import type { TFocusEventHandler } from '@alfa-bank/site-pure-input/src/models';

import { defaultHandler } from './config';
import type { TField } from './models';

/**
 * Адаптер select для fio-field в три поля
 */
export const Field: FC<TField> = ({
    Select,
    caption,
    formatToRussian,
    replacePointSpaceToSpace,
    setCursorPosition,
    deleteExcessSpaceAndDash,
    everyWordToUpperCase,
    getCaption,
    isError,
    isSuccess,
    onBlur = defaultHandler,
    onChange = defaultHandler,
    onClick = defaultHandler,
    onFocus = defaultHandler,
    onSelect = defaultHandler,
    disabled = false,
    forwardedRef,
    field,
    options = [],
    placeholder,
    ...rest
}) => {
    const onBlurHandler: TFocusEventHandler = ({ event, name, value }) => {
        /* удаляем пробелы в начале и конце строки, удяляем тире в конце строки*/
        const formattedValue = String(value).trim().replace(/-$/, '');
        onBlur({ event, value: formattedValue, name });
    };

    return (
        <Select
            {...rest}
            addHiddenInput={disabled}
            appendCurrent
            caption={getCaption(field.meta, caption)}
            disabled={disabled}
            error={isError(field.meta)}
            forwardedRef={forwardedRef}
            name={field.input.name}
            onBlur={({ event, name, value }) => onBlurHandler({ event, name, value })}
            onChange={({ event, name, value }) => {
                const composeFunction = compose(
                    formatToRussian,
                    /*
                     * Мак при нажатии дабл-пробела ставит точку и пробел, которая потом форматируется
                     * в букву 'ю' (точка и 'ю' на одной клавише), поэтому заменяем просто на пробел
                     */
                    replacePointSpaceToSpace,
                    deleteExcessSpaceAndDash,
                    everyWordToUpperCase
                );

                const resultValue = composeFunction(String(value));

                onChange({
                    event,
                    name,
                    value: resultValue,
                });

                // скорректировать положение каретки, после форматирование введенного значения
                setCursorPosition(forwardedRef);
            }}
            onClick={onClick}
            onFocus={({ event, name, value }) =>
                onFocus({ name, value: String(value).trim(), event })
            }
            onSelect={event => onSelect({ ...event, field })}
            options={options}
            placeholder={placeholder}
            success={isSuccess(field.meta)}
            value={field.input.value}
        />
    );
};
